import _defineProperty from "/builds/aspendental/web/apps/aspendental-clearchoice-compare/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/builds/aspendental/web/apps/aspendental-clearchoice-compare/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["color", "icon", "size", "viewBox"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import React from 'react';
import * as iconNames from '../../../assets/images/SVG';

var TAGSvgIcon = function TAGSvgIcon(_ref) {
  var color = _ref.color,
      _ref$icon = _ref.icon,
      icon = _ref$icon === void 0 ? '' : _ref$icon,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? 32 : _ref$size,
      _ref$viewBox = _ref.viewBox,
      viewBox = _ref$viewBox === void 0 ? '0 0 32 32' : _ref$viewBox,
      props = _objectWithoutProperties(_ref, _excluded);

  if (!icon) return null;
  var svgName = icon;
  return React.createElement('svg', _objectSpread({
    width: size,
    height: size,
    color: color,
    viewBox: viewBox,
    fill: color,
    xmlns: 'http://www.w3.org/2000/svg'
  }, props), React.createElement(iconNames[svgName], _objectSpread({
    width: props.width,
    height: props.height
  }, props)));
};

export default TAGSvgIcon;